export enum SalePatternKsefSendOption {
    AccordingToConfiguration = 'AccordingToConfiguration',
    Send = 'Send',
    NotSend = 'NotSend'
}